<div class="row">
    <div class="col">
      <div class="mcd-filter-tag-wrapper">
        <div class="mcd-tag-title">Filter By Equipment Type</div>
        <mat-checkbox *ngFor="let item of equipmentTypeList" [checked]="setCheckedStateForCheckBoxes(4, item.id)"
          (change)="addFilter($event, item.id, 4)">{{item.name}}</mat-checkbox>
      </div>
    </div>
  </div>
